import axios from "axios";
import { getToken } from "../auth/token-store";
import { reauthorizeOn401 } from "../auth/pkce";
const Http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    // 'Authorization': 'Bearer '
  },
  // IIDM-3064 T2: `withCredentials: true` removed. The API is bearer-only (the header above, set
  // per request); sending cookies cross-origin bought nothing and was the audit's CSRF precondition.
  responseType: "json",
});
Http.interceptors.request.use(
  (config: any) => {
    // IIDM-3064 T1: read PER REQUEST — a module-load capture missed every token written later.
    const token = getToken();
    if (config.headers && token) {
      config.headers.Authorization = "Bearer " + token;
    } else {
      delete Http.defaults.headers.common.Authorization;
    }
    return config;
  },
  (error) => {
    // IIDM-2883: was `Promise.reject(error)` with no `return`, so a request
    // interceptor failure resolved as undefined instead of rejecting. This is
    // the path an unopenable request takes. (The response interceptor's
    // fall-through at the end of this file has the same defect and is left for
    // IIDM-2884, which owns the error contract.)
    return Promise.reject(error);
  }
);

Http.interceptors.response.use(
  (response: any) => {
    // const statusCode = response.data.status || response.data.status_code
    // if (statusCode === 403 || statusCode === 401) {
    //  const slug = localStorage.getItem('slug')
    //  localStorage.clear()
    //  sessionStorage.clear()
    //  let redirectUrl = `/${slug}`
    //  if (process.env.REACT_APP_SUB_FOLDER) {
    //    redirectUrl = `/${process.env.REACT_APP_SUB_FOLDER}` + redirectUrl
    //  }
    //  window.location.href = redirectUrl
    // }
    return response;
  },
  (error: any) => {
    // IIDM-2883: a request that never reached the server has NO `response` —
    // an invalid URL, a blocked request, a refused connection, a timeout.
    // Reading `.status` on it threw a TypeError *inside this handler*, which
    // then REPLACED the real error and made the whole class undiagnosable.
    // Reject with the original error so the caller sees what actually failed.
    if (!error || !error.response) {
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      // IIDM-3064 T3: there is no refresh token for a public client (IIDM-3063 T5), so a 401 re-runs
      // the PKCE authorize — silent while the SSO session lives. A second 401 inside the loop
      // window falls back to T1's revoke + logout (no `token=` in any URL). Still rejects with the
      // original error. (Synchronous handler, so the 422 branch keeps returning the response.)
      return reauthorizeOn401().then(() => Promise.reject(error));
    } else if (error.response.status === 422) {
      return error.response;
    } else if (error.response.status === 403) {
      window.location.href = `${process.env.REACT_APP_REDIRECT_URI}`.concat(
        "/access-denied"
      );
    } else if (error.response.status === 500 || error.response.status === 404) {
      // IIDM-2884: these two used to `return "apierror"` — a RESOLVED string. The caller then
      // read `.data` off a string, got `undefined`, and every downstream `response.result` threw.
      // Nothing in the repo ever compared against "apierror" (zero matches outside this file), so
      // rejecting loses no behaviour and gains the real status code for the failure shape.
      return Promise.reject(error);
    }

    // IIDM-2884: this was a bare `Promise.reject(error)` with no `return` — the same defect
    // IIDM-2883 fixed in the request interceptor above and explicitly left here. Without the
    // return, every status not handled above (401 included, after its redirect is set) RESOLVED
    // with `undefined`.
    return Promise.reject(error);
  }
);
export default Http;
